export const MOTION = {
    FAST_1_MS: 200,
    FAST_2_MS: 320,
    FAST_3_MS: 400,
    EASE_OUT: 'cubic-bezier(0.16, 1, 0.3, 1)',
    EASE_IN: 'cubic-bezier(0.6, 0.05, 0.75, 0.2)',
    EASE_IN_OUT: 'cubic-bezier(0.65, 0.05, 0.36, 1)',
} as const;

export const DRILL = {
    LIST_EXIT_MS: MOTION.FAST_1_MS,
    COLUMNS_START_MS: Math.round((MOTION.FAST_2_MS * 2) / 3),
    COLUMN_STAGGER_MS: 60,
} as const;

export const VIEWPORT_MARGIN = 16;

export const PANEL_WIDTH = {
    CATEGORIES_LIST: 230,
    COLUMNS_OPENED: 698,
    COLUMNS_CLOSED: 388,
    HORIZONTAL_PADDING: 2 * 16,
} as const;

export const MAX_PANEL_WIDTH =
    PANEL_WIDTH.CATEGORIES_LIST + PANEL_WIDTH.COLUMNS_OPENED + PANEL_WIDTH.HORIZONTAL_PADDING;
